import React, { useState, useRef } from 'react';
import { Card, Popover, Spin, Skeleton } from 'antd';
import { useNavigate } from 'react-router-dom';
import DashCard from '../../userHistory/components/DashCard';
import Exclamation_stalled from '../../../../assets/exclamation_stalled.svg';
import totalUsers from "../../../../assets/icons/dashboard/TotalUsers.svg";
import totalCourses from "../../../../assets/icons/dashboard/TotalCourse.svg";
import totalCurriCulum from "../../../../assets/icons/dashboard/TotalCurriculum.svg";
import totalGroup from "../../../../assets/icons/dashboard/TotalGroups.svg";
import totalEnrollment from "../../../../assets/icons/dashboard/Total Enrollments.svg";
import activeUsersI from "../../../../assets/icons/dashboard/ActiveUsers.svg";


const DashboardStats = ({
  userCount,
  courseCount,
  bundleCount,
  groupCount,
  enrollmentCount,
  activeDomainCount,
  loading,
  error,
}) => {
  const navigate = useNavigate();
  const [popoverVisible, setPopoverVisible] = useState(false);
  const stalledRef = useRef(null);

  const dashdata = [
    {
      header: "Total Users",
      input: userCount,
      icon: totalUsers,
      onclick: () => navigate("/users"),
      iconClassName: "[filter:invert(47%)_sepia(0%)_saturate(0%)_hue-rotate(0deg)_brightness(90%)_contrast(90%)]",
    },
    {
      header: "Total Courses",
      input: courseCount,
      icon: totalCourses,
      onclick: () => navigate("/books"),
      iconClassName: "[filter:invert(47%)_sepia(0%)_saturate(0%)_hue-rotate(0deg)_brightness(90%)_contrast(90%)]",
    },
    {
      header: "Total Curriculums",
      input: bundleCount,
      icon: totalCurriCulum,
      onclick: () => navigate("/bundles"),
      iconClassName: "[filter:invert(47%)_sepia(0%)_saturate(0%)_hue-rotate(0deg)_brightness(90%)_contrast(90%)]",
    },
    {
      header: "Total Groups",
      input: groupCount,
      icon: totalGroup,
      onclick: () => navigate("/group"),
      iconClassName: "[filter:invert(47%)_sepia(0%)_saturate(0%)_hue-rotate(0deg)_brightness(90%)_contrast(90%)]",
    },
    {
      header: "Total Enrollments",
      input: enrollmentCount,
      icon: totalEnrollment,
      onclick: () => navigate("/enroll"),
      iconClassName: "[filter:invert(47%)_sepia(0%)_saturate(0%)_hue-rotate(0deg)_brightness(90%)_contrast(90%)]",
    },
    {
      header: "All Domain",
      input: activeDomainCount,
      icon: activeUsersI,
      onclick: () => navigate("/domain"),
      iconClassName: "[filter:invert(47%)_sepia(0%)_saturate(0%)_hue-rotate(0deg)_brightness(90%)_contrast(90%)]",
    },
    {
      header: "Stalled Progress",
      icon: Exclamation_stalled,
    },
  ];

  const stalledContent = (
    <Card
      className="!bg-[#FFF8C7] !border-none !rounded-[10px] w-[366px] h-[104px]"
      styles={{ body: { padding: '10px' } }}
    >
      <div className="flex flex-row w-[334px] pb-[6px]">
        <div className="flex flex-row h-8 w-[183px] gap-2">
          <span>
            <img src={Exclamation_stalled} alt="exclamation" />
          </span>
          <div className="flex justify-start items-center font-['Inter'] font-medium text-base leading-none text-[#C77A00] w-[143px]">
            Attention Required
          </div>
        </div>
      </div>
      <div className="w-[334px] h-9 font-['Inter'] font-normal text-sm leading-none text-[#C77A00]">
        10 users or group have inactive learning path for over 30 days
      </div>
    </Card>
  );

  if (error) return <div>Something went wrong. Please try again.</div>;

  return (
    <>
      {popoverVisible && (
        <div className="fixed inset-0 w-screen h-screen backdrop-blur-sm bg-black/10 z-[998]" />
      )}

      <div  className="flex flex-row gap-5 w-full overflow-x-auto overflow-y-hidden whitespace-nowrap [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden" style={{paddingBottom: '16px',justifyContent:"space-between"}} >
        {dashdata.map((item, index) => {
          if (item.header === "Stalled Progress") {
            return (
              <div
                key={index}
                className={`cursor-pointer ${popoverVisible ? "relative z-[999]" : ""}`}
                ref={stalledRef}
              >
                <Popover
                  overlayClassName="[&_.ant-popover-inner]:p-0 [&_.ant-popover-inner-content]:p-0"
                  content={stalledContent}
                  trigger="click"
                  placement="bottomRight"
                  open={popoverVisible}
                  onOpenChange={(visible) => setPopoverVisible(visible)}
                >
                  <DashCard
                    header={item.header}
                    input={item.input}
                    icon={item.icon}
                    iconClassName={item.iconClassName}
                  />
                </Popover>
              </div>
            );
          }

          return (
           <div key={index} className="cursor-pointer">
              <DashCard
                header={item.header}
                input={
                  loading ? (
                    <Skeleton.Input
                      active
                      size="small"
                      style={{ width: 52, height: 24, borderRadius: 6, marginTop: 2 }}
                    />
                  ) : (
                    item.input
                  )
                }
                icon={item.icon}
                iconClassName={item.iconClassName}
                onClick={item.onclick}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default DashboardStats;